import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Services from "./components/Services";
import Menu from "./components/Menu";
import Testimonials from "./components/Testimonials";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import MatchdayCatering from "./components/MatchdayCatering";
import Careers from "./components/Careers";
import { Toaster } from "./components/ui/sonner";

const Home = () => {
  return (
    <div>
      <Header />
      <Hero />
      <About />
      <Services />
      <Menu />
      <Testimonials />
      <Contact />
      <Footer />
    </div>
  );
};

const MatchdayPage = () => {
  return (
    <div>
      <Header />
      <MatchdayCatering />
      <Footer />
    </div>
  );
};

const CareersPage = () => {
  return (
    <div>
      <Header />
      <Careers />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/matchday-catering" element={<MatchdayPage />} />
          <Route path="/careers" element={<CareersPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
